import { z } from "zod";

export const counterpartiesUrlFiltersSchema = z.object({
    counterpartyId: z.string().uuid().optional(),
});

export type CounterpartiesUrlFilters = z.infer<
    typeof counterpartiesUrlFiltersSchema
>;

export function createCounterpartiesUrl(
    filters: CounterpartiesUrlFilters,
): string {
    const serialized = JSON.stringify(
        counterpartiesUrlFiltersSchema.parse(filters),
    );
    if (serialized === "{}") {
        return "/counterparties";
    }

    return `/counterparties?filters=${encodeURIComponent(serialized)}`;
}
